import { action } from "satcheljs";

export const onViewModeInitialized: () => {} = action("onViewModeInitialized");
